let title = ' | Gestor - Comercial Ivaiporã'

const centralBI = {
    path: '/central_bi',
    props: true,
    component: () => import('@/Components/BI/BIContainer.vue'),
    children: [
        {
            path: 'estoquebi',
            name: 'EstoqueBI',
            component: () => import('@/Components/BI/EstoqueBI.vue'),
            meta: {
                title: 'Central BI' + title,
                permission: 'estoque_bi',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Redistribuição de Estoque',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/central_bi/estoquebi',
                    }
                ]
            }
        },
        {
            path: 'girobi',
            name: 'GiroBI',
            component: () => import('@/Components/BI/GiroBI.vue'),
            meta: {
                title: 'Central BI' + title,
                permission: 'giro_bi',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Giro e Cobertura',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/central_bi/girobi',
                    }
                ]
            }
        },
        {
            path: 'vendasbi',
            name: 'VendasBI',
            component: () => import('@/Components/BI/VendasBI.vue'),
            meta: {
                title: 'Central BI' + title,
                permission: 'giro_bi',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Vendas',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/central_bi/vendasbi',
                    }
                ]
            }
        },
        {
            path: 'ajusteestoquebi',
            name: 'AjusteEstoqueBI',
            component: () => import('@/Components/BI/AjusteEstoqueBI.vue'),
            meta: {
                title: 'Central BI' + title,
                permission: 'giro_bi',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Ajuste Estoque',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/central_bi/ajusteestoquebi',
                    }
                ]
            }
        },
        {
            path: 'divergenciasbi',
            name: 'DivergenciasBI',
            component: () => import('@/Components/BI/DivergenciasBI.vue'),
            meta: {
                title: 'Central BI' + title,
                permission: 'divergencias_bi',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Est. Virtual X Divergências BI',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/central_bi/divergenciasbi',
                    }
                ]
            }
        },
        {
            path: 'vendas_vendedor_bi',
            name: 'VendasVendedoresBI',
            component: () => import('@/Components/BI/VendasVendedoresBI.vue'),
            meta: {
                title: 'Central BI' + title,
                permission: 'vendas_vendedor_bi',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Vendas Vendedores BI',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/central_bi/vendas_vendedor_bi',
                    }
                ]
            }
        },
        {
            path: 'analisetvabastecimento',
            name: 'analisetvabastecimento',
            component: () => import('@/Components/BI/AnalisePedidosXAbastecimento.vue'),
            meta: {
                title: 'Central BI' + title,
                permission: 'analise_x_abastecimento_bi',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Análise de Pedidos vs Abastecimento',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/central_bi/analisetvabastecimento',
                    }
                ]
            }
        },

    ]
}

export default centralBI